<script>

export default {
	data: () => ({
		errors: {},
		unchangedRecord: null,
		isLoading: false
	}),

	methods: {
		save()
		{
			if (!this.element || !this.element.$exists) {
				return this.store()
					.catch(this.handleErrors);
			} else {
				return this.update()
					.catch(this.handleErrors);
			}
		},

		delete()
		{
			return this.destroy()
				.catch(this.handleErrors);
		},

		handleErrors(error) {
            let errors = error.response.data.data.errors;

            if (Array.isArray(errors) && errors.length == 1) {
                this.errors = errors[0];
            } else {
                this.errors = error.response.data.data.errors;
			}
            throw error;
		}
	},

	watch: {
        // "element"(newVal, oldVal) {
        //     if (this.unchangedRecord === null) {
        //         this.unchangedRecord = JSON.parse(JSON.stringify(newVal));
        //     }
        // },
	}
};
</script>
